import { render, staticRenderFns } from "./SupplierDetail.vue?vue&type=template&id=0475dd51&scoped=true"
import script from "./SupplierDetail.vue?vue&type=script&lang=js"
export * from "./SupplierDetail.vue?vue&type=script&lang=js"
import style0 from "./SupplierDetail.vue?vue&type=style&index=0&id=0475dd51&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0475dd51",
  null
  
)

export default component.exports